import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.5921 0L29.0647 10.6662V28.2662C29.0647 30.3286 27.4241 32 25.3993 32H6.54841C4.52361 32 2.88281 30.3272 2.88281 28.2662V3.73376C2.88297 1.67136 4.52377 0 6.54857 0H18.5921Z",
      fill: "#36D2AD"
    }, null, -1),
    _createElementVNode("path", {
      d: "M29.0647 10.6662H22.4423C20.4189 10.6662 18.592 8.8072 18.592 6.74464V0L29.0647 10.6662Z",
      fill: "white",
      "fill-opacity": "0.4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.1739 13.3337H8.7009C8.3809 13.3337 8.11914 13.5985 8.11914 13.9257V23.408C8.11914 23.7352 8.3809 24 8.7009 24H19.1737C19.4951 24 19.7555 23.7352 19.7555 23.408V13.9257C19.7566 13.7702 19.696 13.6205 19.587 13.5095C19.4779 13.3985 19.3293 13.3353 19.1737 13.3337H19.1739ZM18.0102 22.2211H9.86474V19.2595L11.6103 17.4822L14.5193 20.4451L16.2649 18.6662L18.0102 20.4451V22.2225V22.2209V22.2211ZM16.8465 17.4822C16.6922 17.4809 16.5397 17.4491 16.3977 17.3888C16.2557 17.3285 16.127 17.2408 16.0189 17.1306C15.9109 17.0205 15.8256 16.8902 15.7679 16.7471C15.7103 16.604 15.6814 16.4509 15.683 16.2966C15.683 15.6422 16.2036 15.1112 16.8465 15.1112C17.4895 15.1112 18.0102 15.6422 18.0102 16.2968C18.0102 16.9512 17.4895 17.4822 16.8465 17.4822Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }